import React, { memo } from "react";
import { Marker } from "react-map-gl";
import { ReactSVG } from "react-svg";
import { imgs } from "@gw/theming";
import { useEnvContext } from "@gw/env-context";
import { MarkersStyled } from "./MarkersStyled";
var Markers = function (_a) {
    var farmers = _a.farmers, activeFarmer = _a.activeFarmer, setActiveFarmer = _a.setActiveFarmer, setSlideIndex = _a.setSlideIndex, isMobile = _a.isMobile;
    var imgsFolder = useEnvContext().imgsFolder;
    return (React.createElement(MarkersStyled, null, farmers.map(function (farmer, index) {
        var isActive = (activeFarmer === null || activeFarmer === void 0 ? void 0 : activeFarmer.id) === farmer.id;
        var iconPlace = imgs.icons.iconPlaceGray;
        return (React.createElement(Marker, { key: farmer.id, latitude: farmer.location.coordinates[0], longitude: farmer.location.coordinates[1] },
            React.createElement("a", { href: "/directory/detail/" + farmer.id, target: "_blank", rel: "noreferrer" },
                React.createElement(ReactSVG, { className: "marker-icon-place " + (isActive ? "active" : ""), src: imgsFolder + "/" + iconPlace, onMouseEnter: function () { return setActiveFarmer(farmer); }, onMouseLeave: function () { return setActiveFarmer(null); } }))));
    })));
};
export default memo(Markers);
//# sourceMappingURL=Markers.js.map